<template>
  <div>
    <ProductsTemplate :isShow="isShow">
      <template slot="title">{{content.title}}</template>
      <template slot="english-title">{{content.desc}}</template>
      <template slot="crumb">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>产品中心</el-breadcrumb-item>
          <el-breadcrumb-item>健康管理一体机</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div class="crumb-area">
          <div class="crumb-item index" @click="toPage()">首页</div>
          <div class="arrow">
            <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
          </div>
          <div class="crumb-item">{{navList[2].title}}</div>
          <div class="arrow">
            <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
          </div>
          <div class="crumb-item">{{content.title}}</div>
        </div>
      </template>
      <template slot="device">
        <div class="wrap device">
          <div class="oneDevice" v-if="imgList.length == 1">
            <div class="device-item" v-for="(item,id) in imgList" :key="id">
              <div class="device-img">
                <img :src="domain+item.img" alt="">
              </div>
              <div class="device-name">{{item.product_name}}</div>
            </div>
          </div>
          <div class="device-list" v-else>
            <div class="device-item" v-for="(item,id) in imgList" :key="id">
              <div class="device-img">
                <img :src="domain+item.img" alt="">
              </div>
              <div class="device-name">{{item.product_name}}</div>
            </div>
          </div>
          <div class="buy-btn" @click="handleForm()">购买咨询</div>
        </div>
      </template>
      
      <template slot="other"> 
        <div v-html="content.content"></div>
        </template>

      <!-- <template slot="sp1"> 智能登录 </template>
      <template slot="sp1-info"> 刷身份证登录快速建立电子健康档案 </template>
      <template slot="sp2"> 自助健康检测 </template>
      <template slot="sp2-info">
        身高、体重、BMI、体温、人体成分、血氧、血压、腰围臀比、十二导心电,血糖、尿酸、胆固醇等参数
      </template>
      <template slot="sp3"> 拓展功能 </template>
      <template slot="sp3-info">
        动脉硬化、骨密度、肺功能、电子视力、心血管、血脂四项、血红蛋白、便捷B超、生化分析等
      </template>
      <template slot="sp4"> 打印报告 </template>
      <template slot="sp4-info"> 支持输出A4版体验报告、热敏报告 </template>
      <template slot="sp5"> 数据上传 </template>
      <template slot="sp5-info">
        数据自动上传于存储;支持与各区域信息平台、第三方管理平台互联互通
      </template> -->
    </ProductsTemplate>
  </div>
</template>


<script>
import { product,setting} from "../../network/http_api";
import { BASEDOMAIN } from "../../common/config";
import ProductsTemplate from "../../components/productTemplate.vue";
export default {
  data() {
    return {
      domain:'',
      isShow: 0,
      content:{},
      id:'',
      imgList:[],
      navList:[]
    };
  },
  components: {
    ProductsTemplate,
  },
  mounted(){
    this.domain = BASEDOMAIN
     this.id = this.$route.query.item_id;
      this.getData()
      this.getNav()
  },
   watch: {
    $route(to, from) {
      //console.log(from); //从哪来
      //console.log(to); //到哪去
       this.id = this.$route.query.item_id;
      this.getData()
    },
  },
  methods: {
    async getNav() {
      let res = await setting();
      if (res.code == 200) {
        this.navList = JSON.parse(res.data.model_setting);
        //console.log("headers", this.navList);
      } else {
        this.$message.error(res.msg);
      }
    },
    async getData() {
      let res = await product(this.id);
      //console.log("solution242424", res.data);
      if (res.code == 200) {
        this.content = res.data;
        this.imgList = JSON.parse(res.data.product_json)
      } else {
        this.$message.error(res.msg);
      }
    },
    handleForm() {
      //console.log("okk");
      this.isShow = +new Date();
    },
    toPage() {
      this.$bus.$emit("headerIdx", 0);
            document.title = '首页';
      this.$router.push("/");
    },
  },
};
</script>

<style lang='scss' scoped>
.wrap {
  width: 1240px;
}
.crumb-area {
  display: flex;
  .crumb-item {
    color: #606266;
  }
  .index {
    cursor: pointer;
  }
  .index:hover {
    color: #1d7bff;
  }
  .arrow {
    width: 18px;
    margin: 0 8px;
    img {
      width: 100%;
    }
  }
}
.device {
margin-top: 66px !important;
}
.oneDevice {
  .device-item {
   margin-right: 40px;
    margin-bottom: 40px;
    .device-img {
      // width: 268px;
      // height: 290px;
        text-align: center;

      img {
        // width: 100%;
      }
    }
    .device-name {
      font-size: 24px;
      font-weight: 600;
      color: #202020;
      text-align: center;
      margin-top: 17px;
    }
  }
}
.device-list {
  display: flex;
  flex-wrap: wrap;
  // width: 1200px;
  // justify-content: space-between;
  .device-item {
    margin-right: 40px;
    margin-bottom: 40px;
    .device-img {
      width: 268px;
      height: 290px;
      img {
        width: 100%;
      }
    }
    .device-name {
      font-size: 24px;
      font-weight: 600;
      color: #202020;
      text-align: center;
      margin-top: 17px;
    }
  }
}
.buy-btn {
  width: 264px;
  height: 60px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 24px;
  margin-top: 53px;
  margin-bottom: 34px;
  background: #1d7bff;
  margin-left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  cursor: pointer;
}
</style>